/**
 * Some endpoints (rounds, rounds-final, rounds/player-stats) send money already divided by 100
 * (`"12.34"`, `"0.0300000000000000000000"`), while `formatMoney`/`MoneyCell` take integer cents.
 * This shifts the decimal point back exactly, rounding half up at the third decimal.
 */
const DECIMAL = /^([+-]?)(\d+)(?:\.(\d+))?$/;

export function majorToCents(value: string | number | null | undefined): string | null {
  if (value === null || value === undefined) return null;
  const text = typeof value === 'number' ? (Number.isFinite(value) ? value.toFixed(4) : '') : value.trim();
  const match = DECIMAL.exec(text);
  if (!match) return null;
  const [, sign = '', whole = '0', frac = ''] = match;
  let cents = BigInt(whole) * 100n + BigInt(frac.padEnd(2, '0').slice(0, 2));
  if ((frac[2] ?? '0') >= '5') cents += 1n;
  return cents === 0n || sign !== '-' ? cents.toString() : `-${cents.toString()}`;
}
